import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";

@Component({ name: "MessagePreviewMixin" })
export default class MessagePreviewMixin extends Vue {
  @Prop({ required: true })
  public message!: Message;

  @Prop({ type: String, required: true })
  public authUserId!: string;
}
